import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { ImageContainer, InnerContainer, TimeLocationContainer } from './styles'
import moment from 'moment'
import { handleLocalStorage } from 'featureSliced/shared/hooks/handleLocalStorage'

import { ReactComponent as TimeImg } from 'assets/TimeLocation/timeNew.svg'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { IconFilled } from 'components/IconsContainers/styled'

export const Time = () => {
  const t = useTranslations()
  const color = useMySelector((state) => state.app.interfaceStyles.FontColor)
  const { pickUpTime } = handleLocalStorage(['pickUpTime'])

  return (
    <InnerContainer>
      <ImageContainer>
        <IconFilled color={color}>
          <TimeImg />
        </IconFilled>
      </ImageContainer>
      {/* TODO: translations */}
      <p>Abholdatum und Zeit:</p>
      <p>
        {t('common.dayDateTime', {
          dateMonth: moment(pickUpTime).format('DD MMMM'),
          time: moment(pickUpTime).format('HH:mm'),
        })}
      </p>
    </InnerContainer>
  )
}
